import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=2e734d4e&scoped=true"
import script from "./QuotationForm.vue?vue&type=script&lang=js"
export * from "./QuotationForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationForm.vue?vue&type=style&index=0&id=2e734d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e734d4e",
  null
  
)

export default component.exports